import React from "react";

function BotCard({ bot, handleBotClick, dischargeBot, inArmy = false }) {
  console.log('handleBotClick function:', handleBotClick); // Debugging statement

  const handleDischarge = (e) => {
    e.stopPropagation();
    dischargeBot(bot);
  };

  return (
    <div className="bot-card" onClick={() => handleBotClick(bot)}>
      <img src={bot.avatar_url} alt={bot.name} />
      <h3>{bot.name}</h3>
      <p>{bot.catchphrase}</p>
      <p>
        <strong>Class:</strong> {bot.bot_class}
      </p>
      <p>
        <strong>Health:</strong> {bot.health}
      </p>
      <p>
        <strong>Damage:</strong> {bot.damage}
      </p>
      <p>
        <strong>Armor:</strong> {bot.armor}
      </p>
      {inArmy && (
        <button onClick={handleDischarge} className="discharge-btn">
          x
        </button>
      )}
    </div>
  );
}

export default BotCard;
